import Header from "../../components/Header";
import ComplianceGenerate from "../../components/compliance/ComplianceGenerate";
import PayrollMonthFilter from "../../components/compliance/PayrollMonthFilter";

const ComplianceGeneratePage = () => {

    return (
        <div>
            <Header title="Compliance Generate" />

            <PayrollMonthFilter />

           <ComplianceGenerate />

        </div>
    );
};

export default ComplianceGeneratePage;